import { useGetConductTypesForSchoolQuery } from '@schooly/api';
import { ArchiveIcon, Spin } from '@schooly/style';
import { TagSelect } from '@schooly/style';
import { TagSelectProps } from '@schooly/style';
import { useMemo } from 'react';
import { FC } from 'react';

export type ConductTypeOptionTagSelectProps = {
  schoolId: string;
  label: string;
  conductTypeId: string;
} & TagSelectProps;

export const ConductTypeOptionTagSelect: FC<ConductTypeOptionTagSelectProps> = ({
  label,
  schoolId,
  conductTypeId,
  ...props
}) => {
  const { data } = useGetConductTypesForSchoolQuery(schoolId, { enabled: !!schoolId });

  const { archived, conductType } = useMemo(() => {
    const conductType = data?.find((t) => t.id === conductTypeId);
    const archived = conductType?.select_type_options?.find((o) => o.label === label)?.archived;

    return { archived, conductType };
  }, [conductTypeId, data, label]);

  return (
    <TagSelect
      label={conductType ? `${conductType.name} • ${label}` : <Spin />}
      icon={archived ? <ArchiveIcon /> : undefined}
      {...props}
    />
  );
};
